<!--
 * @FileDescription: 用户支付流水
 * @Author: 陈文景
 * @Date: 2022-10-13 09:26:50
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <page-skeleton>
    <template slot="header-left">
      <el-select v-model="parameter.paymentTypeList" size="medium" multiple collapse-tags clearable placeholder="选择支付类型"
        @change="getPaymentStreamList">
        <el-option v-for="item in paymentTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-select v-model="parameter.paymentMethodList" size="medium" multiple collapse-tags clearable placeholder="选择支付方式"
        @change="getPaymentStreamList">
        <el-option v-for="item in paymentModeOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-select v-model="parameter.statusList" size="medium" placeholder="选择支付状态" @change="selectPaymentStatus">
        <el-option v-for="item in paymentStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <!-- <div class="payment-status">
        
      </div> -->
      <el-date-picker v-model="parameter.paymentTime" size="medium" type="datetimerange" range-separator="~"
        :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss" @change="changeDatePicker" />
      <batch-search :option="conditionOptins" :selected="parameter.searchType" @select="searchType" @search="search"
        @clear="clear" />

      <!-- 流水导出 -->
      <el-button type="primary" @click="dataExport" style="height: 36px; margin-left: 10px">数据导出</el-button>
    </template>

    <template slot="container">
      <el-table v-loading="loading" :data="payments" size="medium" row-key="id" :style="{ width: `${tableWidth}%` }"
        :height="`${tableHeight}%`">
        <el-table-column label="KakaClo单号">
          <template v-slot="{ row }">
            <el-tooltip effect="dark" placement="top">
              <span slot="content" v-html="setWrap(defaultTips(getKakaCloOrderId(row.kkOrders)))" />
              <copy class="kakaclo-order-id" :text="defaultTips(getKakaCloOrderId(row.kkOrders))" />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="第三方交易单号">
          <template v-slot="{ row }">
            {{ defaultTips(row.thirdPlatformPaymentNo) }}
          </template>
        </el-table-column>
        <el-table-column sortable label="交易时间" :sort-method="sortCompletionTime">
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.completionTime)) }}
          </template>
        </el-table-column>
        <el-table-column sortable label="交易金额" :sort-method="sortAmount">
          <template v-slot="{ row }">
            <span :class="row.incomeType === 0 ? 'disable' : row.incomeType === 1 ? 'enable' : ''">{{ `${row.incomeType
              === 0 ? '-' : row.incomeType === 1 ? '+' : ''} USD${defaultTips(row.amount)}` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template v-slot="{ row }">
            {{ getPaymentType(row.paymentType) }}
          </template>
        </el-table-column>
        <el-table-column label="支付状态">
          <template v-slot="{ row }">
            {{ getPaymentStatus(row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="支付方式">
          <template v-slot="{ row }">
            {{ getPaymentMethod(row.paymentMethod) }}
          </template>
        </el-table-column>
        <el-table-column label="邮箱/手机号">
          <template v-slot="{ row }">
            {{ defaultTips(row.email) }}
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template v-slot="{ row }">
            {{ defaultTips(row.note) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{ $index, row }">
            <el-button type="text" v-if="row.paymentType === -1 && row.status === -2"
              @click="completed($index, row)">手动完结</el-button>
            <el-button type="text" v-if="row.paymentType === -1 && row.status === -2"
              @click="retry($index, row)">重试</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]"
        :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
        class="el-pagination" @size-change="sizeChange" @current-change="currentChange" />
    </template>
    <!-- 交易流水导出对话框 -->
    <TransactionExport ref="transactionExport" :parameter="parameter" />
  </page-skeleton>
</template>

<script>
import API from '@/api'
import Copy from '@/components/copy.vue'
import BatchSearch from '@/components/BatchSearch.vue'
import PageSkeleton from '@/components/PageSkeleton.vue'
import { formatTimeStamp, toTimeStamp } from '@/utils/moment'
import TransactionExport from './TransactionExport.vue'

export default {
  name: 'user_payment',
  components: {
    copy: Copy,
    'batch-search': BatchSearch,
    'page-skeleton': PageSkeleton,
    TransactionExport
  },
  data() {
    return {
      // 获取支付流水的请求参数
      parameter: {
        paymentTypeList: [], // 支付类型双向绑定的值
        paymentMethodList: [], // 支付方式双向绑定的值
        statusList: 1024, // 支付状态双向绑定的值
        paymentTime: [], // 支付时间双向绑定的值(请求前需要删除)
        completionTimeStart: undefined, // 开始时间
        completionTimeEnd: undefined, // 结束时间
        searchType: 1, // 根据条件类型搜索双向绑定的值(条件)
        searchContent: undefined, // 根据条件类型搜索双向绑定的值(以逗号隔开并且数量不超过50)
        pageSize: 20,
        pageNumber: 1
      },

      // 支付类型下拉选项
      paymentTypeOptions: [
        { label: '退款', value: -1 },
        { label: '购买', value: 0 },
        { label: '一件代发', value: 1 },
        { label: '样品', value: 2 },
        { label: '充值', value: 3 },
        { label: '订货(尾款)', value: 4 },
        { label: '订货(押金)', value: 5 },
        { label: 'BILL(账单支付)', value: 7 }
      ],

      // 支付方式下拉选项
      paymentModeOptions: [
        { label: 'Balance', value: 0 },
        { label: 'Credit Card', value: 1 },
        { label: 'Paypal', value: 2 },
        { label: 'Airwallex', value: 3 },
        { label: 'KakaClo', value: 4 },
        { label: 'Gift Card', value: 5 },
        { label: 'Credit', value: 6 },
        { label: 'Authorized', value: 7 },
        { label: '40Seas', value: 8 },
        { label: 'Payoneer', value: 9 },
      ],

      // 支付状态下拉选项
      paymentStatusOptions: [
        { label: '全部', value: 1024 },
        { label: '异常', value: -2 },
        { label: '取消', value: -1 },
        { label: '未完成', value: 0 },
        { label: '待校验', value: 1 },
        { label: '已完成', value: 2 }
      ],

      // 根据条件类型搜索下拉选项
      conditionOptins: [
        { label: 'kk订单ID', value: 1 },
        { label: '第三方支付ID', value: 2 },
        { label: '邮箱/手机号', value: 3 }
      ],

      tableWidth: 100, // 表格宽度
      tableHeight: 100, // 表格高度

      formatTimeStamp, // 格式化时间戳

      // 支付流水列表
      payments: [],
      total: 0, // 支付流水列表总数量
      loading: false // 表格loading
    }
  },
  created() {
    this.getPaymentStreamList()
  },
  activated() {
    this.getPaymentStreamList()
  },
  computed: {
    getKakaCloOrderId() {
      return (array) => {
        let orderIds = []
        array &&
          array.forEach((item) => {
            orderIds.push(item.kkOrderId)
          })
        return orderIds.join(',')
      }
    },
    setWrap() {
      return (value) => {
        let result = value && value.split(',')
        return (
          result &&
          result
            .map((item, index) => {
              if (index === result.length - 1) {
                return item
              } else {
                return `${item} <br />`
              }
            })
            .filter(Boolean)
            .join(',')
        )
      }
    },
    getPaymentType() {
      return (type) => {
        switch (type) {
          case -1:
            return '退款'
          case 0:
            return '购买'
          case 1:
            return '一件代发'
          case 2:
            return '样品'
          case 3:
            return '充值'
          case 4:
            return '订货(尾款)'
          case 5:
            return '订货(押金)'
          case 7:
            return 'BILL(账单支付)'
          default:
            return '-'
        }
      }
    },
    getPaymentMethod() {
      return (type) => {
        switch (type) {
          case 0:
            return 'Balance'
          case 1:
            return 'Credit Card'
          case 2:
            return 'Paypal'
          case 3:
            return 'Airwallex'
          case 4:
            return 'KakaClo'
          case 5:
            return 'Gift Card'
          case 6:
            return 'Credit'
          case 7:
            return 'Authorized'
          case 8:
            return '40Seas'
          case 9:
            return 'Payoneer'
          default:
            return '-'
        }
      }
    },
    getPaymentStatus() {
      return (type) => {
        switch (type) {
          case -2:
            return '异常'
          case -1:
            return '取消'
          case 0:
            return '未完成'
          case 1:
            return '待校验'
          case 2:
            return '已完成'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 获取支付流水列表
     * @param {Boolean} reset 是否重置分页
     */
    async getPaymentStreamList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let newParameter = { ...this.parameter }
        if (newParameter.statusList === 1024) {
          newParameter.statusList = [-2, -1, 0, 1, 2]
        } else {
          newParameter.statusList = [newParameter.statusList]
        }
        newParameter.completionTimeStart = toTimeStamp(newParameter.completionTimeStart)
        newParameter.completionTimeEnd = toTimeStamp(newParameter.completionTimeEnd)
        delete newParameter.paymentTime
        let { data } = await API.getPaymentStreamList(newParameter)
        this.total = data.total
        this.payments = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 时间日期选择器的回调事件
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        this.parameter.completionTimeStart = date[0]
        this.parameter.completionTimeEnd = date[1]
      } else {
        this.parameter.completionTimeStart = null
        this.parameter.completionTimeEnd = null
      }
      this.getPaymentStreamList()
    },

    /**
     * 选择支付状态的回调
     */
    selectPaymentStatus() {
      this.getPaymentStreamList()
    },

    /**
     * 选择搜索类型的回调
     * @param {String} value 当前选中的值
     */
    searchType(value) {
      this.parameter.searchType = value
      if (this.parameter.searchContent) {
        this.getPaymentStreamList()
      }
    },

    /**
     * 搜索按钮触发的回调
     * @param {String} value
     */
    search(value) {
      this.parameter.searchContent = value.trim()
      this.getPaymentStreamList()
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    clear() {
      this.parameter.searchContent = undefined
      this.getPaymentStreamList()
    },

    /**
     * 数据导出
     */
    dataExport() {
      this.$refs.transactionExport.show()
    },

    /**
     * 表格交易时间字段排序
     * @param {Object} a 第一行数据
     * @param {Object} b 第二行数据
     */
    sortCompletionTime(a, b) {
      if (a.completionTime > b.completionTime) {
        return -1
      }
    },

    /**
     * 表格交易金额字段排序
     * @param {Object} a 第一行数据
     * @param {Object} b 第二行数据
     */
    sortAmount(a, b) {
      if (a.amount > b.amount) {
        return -1
      }
    },

    /**
     * 完结异常流水订单
     * @param {Object} index 列表index
     * @param {Object} row 行数据
     */
    completed(index, row) {
      this.$confirm('此操作会将流水完结, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.completedPayment(row.paymentId).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          // 从当前列表移除
          this.payments.splice(index, 1)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    /**
     * 重试异常流水订单
     * @param {Object} index 列表index
     * @param {Object} row 行数据
     */
     retry(index, row) {
      API.retryPayment(row.paymentId).then((res) => {
          this.$message({
            type: 'success',
            message: '重试成功,进入待处理!'
          });
          // 从当前列表移除
          this.payments.splice(index, 1)
        })
    },

    /**
     * 每页显示条数发生改变时的回调
     * @param {Number} size 每页显示条数
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getPaymentStreamList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     * @param {Number} current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getPaymentStreamList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-status {
  display: inline-block;

  .el-select {
    width: 120px;

    /deep/.el-input__inner {
      border-right: 0 !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;

      &:focus,
      &:active,
      &:visited,
      &:focus {
        border-color: #dcdfe6 !important;
      }
    }
  }

  .el-date-editor {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}

.kakaclo-order-id {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.enable {
  color: #99c41c;
}

.disable {
  color: #f56c6c;
}
</style>
